import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiCustomFields {
  static getCustomFields(appId, fieldType) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/custom_fields?field_type=${fieldType}`);
  }

  static updateCustomField(appId, fieldId, field) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/custom_fields/${fieldId}`, {
      method: "PUT",
      body: { custom_field: field },
    });
  }

  static createCustomField(appId, field) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/custom_fields`, {
      method: "POST",
      body: { custom_field: field },
    });
  }

  static async deleteCustomField(appId, fieldId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/custom_fields/${fieldId}`, {
      method: "DELETE",
    }).then(_ => fieldId);
  }
}
